import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { getFormLabelKey, getGridLabelKey } from "@ryde/shared";

import { usePageContext } from "../contexts";
import { useResolveEditFormEntity } from "./admin/use-resolve-edit-form-entity";

export const useDynamicFormsTranslate = ({
  name,
  fallbackText,
  translatedText,
}: {
  name?: string;
  fallbackText?: string | null;
  translatedText?: string;
}) => {
  const { t } = useTranslation();
  const { entity: gridEntity } = usePageContext();
  const formEntity = useResolveEditFormEntity();

  const formLabelTranslated = useMemo(() => {
    if (translatedText) {
      return translatedText;
    }

    if (!name || !formEntity || formEntity === "unknown") {
      return fallbackText || "";
    }

    const formLabelKey = getFormLabelKey(formEntity, name);
    return t(formLabelKey);
  }, [fallbackText, formEntity, name, t, translatedText]);

  const gridLabelTranslated = useMemo(() => {
    if (!name || !gridEntity || gridEntity === "unknown") {
      return fallbackText || "";
    }

    const gridLabelKey = getGridLabelKey(gridEntity, name);
    return t(gridLabelKey);
  }, [fallbackText, gridEntity, name, t]);

  return {
    formLabelTranslated,
    gridLabelTranslated,
  };
};
